export const splitExperiments = {
  hcPlatMigrationKnowledgeBase: 'e2-hc-plat-migration-knowledge-base',
  hcPlatMigrationTicketing: 'e2-hc-plat-migration-ticketing',
  hcPlatMigrationEntitlements: 'e2-hc-plat-migration-service-entitlements',
};
